const CHROME_ACTION_TYPES = {
  LOAD_CHROME: 'chrome/LOAD_CHROME',
};

export default CHROME_ACTION_TYPES;
